import React, { useState, useEffect } from "react";
import NewArrivals from "../components/home/NewArrivals";
import BestSellers from "../components/home/BestSellers";
import HoliSection from "../components/home/HoliSection";
import CategoryList from "../components/category/CategoryList";
import SubList from "../components/sub/SubList";
import { Carousel, Divider } from 'antd';
import { Link, useHistory } from "react-router-dom";
import { useMediaQuery } from 'react-responsive'
import HomeCategory from "../components/home/HomeCategory";
import { getCategories } from "../functions/category";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "./Modal"
import logo from "../components/nav/logo.png"
import AddressForm from "../components/forms/AddressForm";
import Plasma from "./ExtraPages/Plasma";
import moment from 'moment'
import SpecialClass from "../components/home/SpecialClass";
import ShoppingListIcon from "./user/ShoppingListIcon";
import PinCode from "../components/Address/PinCode";
import DealCategory from "../components/home/DealCategory";
import BigDeals from "../components/home/BigDeals";
import Banner from "../components/Banners.js/Banner";
import { Helmet } from "react-helmet";
import DeliveryType from "../components/nav/DeliveryType";
import MapView from "../components/nav/MapView";
import Content from "../components/Banners.js/OptimaInfo";
import {
    getCoupons,
} from "../functions/coupon";

const NewHome = () => {

    const { user } = useSelector((state) => ({ ...state }));


    return (
        <div className="margin-bottom--one pdl-generic-content_container--max">
            <HomeCategory />

            <SpecialClass tag="weekly-flyer" name="Shop our Pamphlet" />

            <Divider />

            {/* <HoliSection pullCategory="chips-nuts-and-namkeen" name="Try Internation for Less " /> */}

            <Divider />

            <SpecialClass tag="d.-winter-special" name="Winter Essentials ❄️" />

            <Divider />


            <BigDeals />


            <br />

            <Divider />



            {user ? (
                <ShoppingListIcon button="Shopping List" newLink="user/wishlist" />
            ) : (
                    <ShoppingListIcon button="Shop Now" newLink="shop" />
                )
            }

            <SpecialClass tag="imported" name="Imported Foods 🍫" />

            {/* <Divider /> */}

            {/* <SpecialClass tag="father-day" name="Gift Options" /> */}

            <Divider />

            <Content />

        </div>
    )
}

export default NewHome
